import { render, staticRenderFns } from "./LessonLogDialog.vue?vue&type=template&id=40515c88&"
import script from "./LessonLogDialog.vue?vue&type=script&lang=ts&"
export * from "./LessonLogDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports